import { find } from 'lodash';

// Map/Reduce for Entries with included Users
export const reduceEntriesToUserEntries = entries => {
  const userEntries = entries.data
    .map(entry => ({
      userId: entry.relationships.user.data.id,
      questionId: entry.relationships.question.data.id,
      attributes: entry.attributes,
      rank: entry.attributes.rank,
      value:
        entry.attributes.calculated && entry.attributes.value
          ? entry.attributes.value
          : 0,
    }))
    .reduce((accumulator, entry) => {
      if (entry.userId in accumulator) {
        accumulator[entry.userId].entries[entry.questionId] = entry.attributes;
        accumulator[entry.userId].score += entry.value;
      } else {
        accumulator[entry.userId] = {
          user: find(entries.included, { id: entry.userId }),
          entries: {
            [entry.questionId]: entry.attributes,
          },
          score: entry.value,
          rank: entry.rank,
        };
      }

      return accumulator;
    }, {});

  return userEntries;
};
